<div [matMenuTriggerFor]="mediaMenu" id="RecipesModifyStepsStepPictureBtn{{ formArrayIndex }}">
  <ng-container *ngIf="getMedia() as resourceMedia; else noResourceMedia">
    <ng-container *ngIf="resourceMedia.media">
      <!-- display photo thumbnail-->
      <img
        [src]="resourceMedia.media.thumbnail"
        *ngIf="resourceMedia.media.type === 'PHOTO'"
        alt="cover"
        width="{{ imgPlaceHolderWidth }}"
      />

      <!-- display video thumbnail if available or link to video otherwise -->
      <ng-container *ngIf="resourceMedia.media.type === 'VIDEO'">
        <ng-container *ngIf="!resourceMedia.media.thumbnail">
          <video
            (click)="selectedMedia(resourceMedia.identifier)"
            *ngIf="!isYoutubeVideo(resourceMedia.media.original); else youtubeTemplate"
            [controls]="false"
            [style.height]="imgPlaceHolderHeight + 'px'"
            [style.width]="imgPlaceHolderHeight + 'px'"
          >
            <source
              [src]="resourceMedia.media.original + '?fit=CROP&w=' + imgPlaceHolderWidth + '&h=' + imgPlaceHolderHeight"
              type="video/mp4"
            />
          </video>
          <ng-template #youtubeTemplate>
            <div
              class="stop-click-video"
              [style.height]="imgPlaceHolderHeight"
              [style.width]="imgPlaceHolderHeight"
              (click)="selectedMedia(resourceMedia.identifier)"
            ></div>
            <iframe
              [src]="transformForYoutube(resourceMedia.media.original) | safeUrl"
              width="{{ imgPlaceHolderWidth }}"
              height="{{ imgPlaceHolderHeight }}"
              allowfullscreen
              title="youtube-video"
            ></iframe>
          </ng-template>
        </ng-container>
        <img
          *ngIf="resourceMedia.media.thumbnail"
          [src]="resourceMedia.media.thumbnail + '?fit=CROP&w=' + imgPlaceHolderWidth + '&h=' + imgPlaceHolderHeight"
          [style.height]="imgPlaceHolderHeight"
          [style.width]="imgPlaceHolderHeight"
          width="{{ imgPlaceHolderWidth }}"
          alt="youtube-thumbnail"
        />
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #noResourceMedia>
    <img [src]="'assets/images/no-picture.jpg'" alt="cover" width="{{ imgPlaceHolderWidth }}" />
  </ng-template>
</div>

<mat-menu #mediaMenu="matMenu" xPosition="before">
  <ng-template matMenuContent>
    <div class="image-list" id="RecipesModifyStepsStepPictureLstBtn">
      <img [src]="'assets/images/no-picture.jpg'" (click)="selectedMedia(undefined)" class="image-media" alt="cover" />
      <ng-container *ngFor="let img of variant?.resourceMedias; let index = index">
        <img
          [src]="img.media.thumbnail"
          (click)="selectedMedia(img.identifier)"
          *ngIf="img.media.type === 'PHOTO'"
          class="image-media"
          alt="cover"
        />
        <video
          (click)="selectedMedia(img.identifier)"
          *ngIf="img.media.type === 'VIDEO' && !isYoutubeVideo(img.media.original)"
          [controls]="false"
          class="image-media"
        >
          <source [src]="img.media.original + '?fit=CROP&w=200&h=200'" type="video/mp4" />
        </video>
        <div *ngIf="img.media.type === 'VIDEO' && isYoutubeVideo(img.media.original)" style="display: inline-block">
          <div class="stop-click-video stop-click-video-small" (click)="selectedMedia(img.identifier)"></div>
          <iframe
            [src]="transformForYoutube(img.media.original) | safeUrl"
            width="200"
            height="200"
            allowfullscreen
            *ngIf="!img.media.thumbnail"
            class="image-media"
            title="youtube-video-2"
          ></iframe>
          <img
            *ngIf="img.media.thumbnail"
            [src]="img.media.thumbnail + '?fit=CROP&w=200&h=200'"
            class="image-media"
            alt="youtube-thumbnail-2"
          />
        </div>
      </ng-container>
    </div>
  </ng-template>
</mat-menu>
